// src/components/Icon.js
// Reusable SVG icons in colored circular backgrounds

const paths = {
  check: <polyline points="20 6 9 17 4 12"/>,
  x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
  clock: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
  doc: <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
  edit: <><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></>,
  link: <><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></>,
  share: <><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></>,
  calendar: <><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
  dollar: <><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></>,
  creditCard: <><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></>,
  users: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
  camera: <><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></>,
  paperclip: <><path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/></>,
  star: <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
  save: <><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></>,
  archive: <><polyline points="21 8 21 21 3 21 3 8"/><rect x="1" y="3" width="22" height="5"/><line x1="10" y1="12" x2="14" y2="12"/></>,
  mail: <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22 6 12 13 2 6"/></>,
  lock: <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>,
  heart: <><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></>,
  alert: <><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
  download: <><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
  send: <><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>,
  shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></>,
  home: <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
  refresh: <><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></>,
  info: <><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></>,
  chat: <><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></>,
  zelle: <><path d="M6 4h12l-12 16h12"/></>,
  venmo: <><path d="M18 4c1 1.5 1.5 3 1.5 5 0 5.5-4.5 12.5-8 17H5l-2-17 6-.5 1 10.5c1.5-2.5 3.5-6.5 3.5-9 0-1.5-.5-2.5-.5-2.5L18 4z"/></>,
};

export const SvgIcon = ({ name, size = 18, color = 'white', strokeWidth = 2.2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    {paths[name]}
  </svg>
);

export const CircleIcon = ({ name, color = 'var(--primary)', size = 38, iconSize = 18, style }) => (
  <div style={{
    width: size, height: size, borderRadius: '50%', flexShrink: 0,
    background: color, display: 'flex', alignItems: 'center', justifyContent: 'center',
    ...style,
  }}>
    <SvgIcon name={name} size={iconSize} />
  </div>
);

// Brand logos as standalone SVG components
export const ZelleLogo = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#6001D2"/>
    <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="22" fill="white">Z</text>
  </svg>
);

export const VenmoLogo = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M18 4c1 1.5 1.5 3 1.5 5 0 5.5-4.5 12.5-8 17H5l-2-17 6-.5 1 10.5c1.5-2.5 3.5-6.5 3.5-9 0-1.5-.5-2.5-.5-2.5L18 4z" fill="#3D95CE"/>
  </svg>
);

export const StripeLogo = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="1" y="4" width="22" height="16" rx="3" fill="#635BFF"/>
    <path d="M12 9c-2 0-3 .7-3 1.8 0 2.2 4.5 1.8 4.5 3.4 0 .5-.5.8-1.5.8-1.3 0-2.5-.5-3.5-1.2v2.2c1 .5 2 .8 3.5.8 2.2 0 3.5-.9 3.5-2.2 0-2.3-4.5-1.9-4.5-3.4 0-.4.4-.7 1.3-.7 1 0 2.2.4 3.2 1V9.5c-1-.4-2-.5-3-.5z" fill="white"/>
  </svg>
);

export const GoogleCalendarLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none">
    {/* Outer rounded square */}
    <rect x="20" y="20" width="160" height="160" rx="16" fill="white"/>
    {/* Top bar - blue */}
    <rect x="20" y="20" width="160" height="40" rx="16" fill="#4285F4"/>
    <rect x="20" y="44" width="160" height="16" fill="#4285F4"/>
    {/* Calendar hooks */}
    <rect x="60" y="8" width="12" height="36" rx="6" fill="#4285F4"/>
    <rect x="128" y="8" width="12" height="36" rx="6" fill="#4285F4"/>
    {/* Border */}
    <rect x="20" y="20" width="160" height="160" rx="16" stroke="#DADCE0" strokeWidth="3" fill="none"/>
    {/* Date text - 31 */}
    <text x="100" y="142" textAnchor="middle" fontFamily="'Noto Sans', sans-serif" fontWeight="700" fontSize="72" fill="#4285F4">31</text>
    {/* Google 4-color dots bottom-left */}
    <circle cx="50" cy="164" r="6" fill="#4285F4"/>
    <circle cx="66" cy="164" r="6" fill="#EA4335"/>
    <circle cx="82" cy="164" r="6" fill="#FBBC05"/>
    <circle cx="98" cy="164" r="6" fill="#34A853"/>
  </svg>
);

export const AppleCalendarLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none">
    {/* Rounded square body */}
    <rect x="16" y="16" width="168" height="168" rx="32" fill="white"/>
    <rect x="16" y="16" width="168" height="168" rx="32" stroke="#E0E0E0" strokeWidth="2"/>
    {/* Red top bar */}
    <clipPath id="appleTopClip">
      <rect x="16" y="16" width="168" height="48" rx="32"/>
    </clipPath>
    <rect x="16" y="16" width="168" height="56" fill="#FF3B30" clipPath="url(#appleTopClip)"/>
    <rect x="16" y="48" width="168" height="16" fill="#FF3B30"/>
    {/* Month label */}
    <text x="100" y="56" textAnchor="middle" fontFamily="'Noto Sans', sans-serif" fontWeight="700" fontSize="22" fill="white" letterSpacing="2">JUL</text>
    {/* Date number */}
    <text x="100" y="148" textAnchor="middle" fontFamily="'Noto Sans', sans-serif" fontWeight="300" fontSize="82" fill="#333">17</text>
  </svg>
);

export const OutlookCalendarLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="18" height="18" rx="2" fill="white" stroke="#0078D4" strokeWidth="1.5"/>
    <rect x="3" y="3" width="18" height="6" rx="2" fill="#0078D4"/>
    <line x1="8" y1="1" x2="8" y2="5" stroke="#0078D4" strokeWidth="2" strokeLinecap="round"/>
    <line x1="16" y1="1" x2="16" y2="5" stroke="#0078D4" strokeWidth="2" strokeLinecap="round"/>
    <text x="6.5" y="18.5" fontFamily="Noto Sans, sans-serif" fontWeight="800" fontSize="9" fill="#0078D4">O</text>
  </svg>
);

export default CircleIcon;
